module.exports = __webpack_public_path__ + "img/seat-7.df7505d9.jpg";